import { render, staticRenderFns } from "./ButtonSimple.vue?vue&type=template&id=2679a72d"
import script from "./ButtonSimple.vue?vue&type=script&lang=js"
export * from "./ButtonSimple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports